import React, {
  forwardRef, useEffect, useMemo, useState,
} from 'react';
import { NavLink, useHistory, useParams } from 'react-router-dom';
import 'moment-timezone';
import _ from 'lodash';
import MaterialTable, { MTableBody, MTableHeader } from 'material-table';
import {
  Card, Form, Row, Col, Button,
  Badge,
} from 'react-bootstrap';

import { History, ThreeDRotation } from '@material-ui/icons';
import DownloadLink from '../common/DownloadLink';
import PassportVersionHistoryModal from '../../pages/project/PassportVersionHistoryModal';

import { years, tableIcons } from "../../helpers";
import {
  getStickyActionAndStatus,
  localization,
  objectToCols,
  styledHeaderSticky,
  arrayToLookup,
  modifyDefaultOptions, getStickyColumns
} from "../../helpers/table";
import { status as PS, status_ru_extra, filterStatus } from "../../helpers/passport";

import { arrayStringRenderer, dateRenderer, floatRenderer } from '../../services/formatSvc';

import useAPI from '../../hooks/useAPI';
import useUserContext from '../../hooks/useUserContext';
import useToast from '../../hooks/useToast';
import ConfirmModal from '../common/ConfirmModal';
import { isAdmin, isPortfolioTeam, isProjectTeam } from '../../services/rolesSvc';
import ModalSendForRevision from '../common/ModalSendForRevision';
import ModalSendForRevisionWithDate from '../common/ModalSendForRevisionWithDate';
import StatusBadge from '../common/StatusBadge';
import TooltippedElement from '../common/TooltippedElement';
import { status_ru_m as status } from '../../helpers/factdata';
import style from './style.less';
import FilterMultiSelect from '../table/FilterMultiSelect';
import moment from 'moment';
import '../MaterialTableOverrides.less'
import {FactDataActions} from "../common/Actions/FactDataActions";
import SlicedNameData from "../table/SlicedData";
import {BaseRequests} from "../../requests/BaseRequests";

const roles = {
  head: 'Руководитель проекта',
  admin: 'Администратор проекта',
  participantAdmin: 'Участник с правами администратора',
  participant: 'Участник',
};

export default function TableProject({ year, setEditMemberID, filterStatus,projStatus,...rest }) {
  const {canEdit}={...rest}
  const api = useAPI();
  const toast = useToast();
  const history = useHistory();
  const userCtx = useUserContext();
  const { projId, stratId, policyId, portfolioId } = useParams();

  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(true);
  const [members, setMembers] = useState([]);
  const [isModalDelete, setIsModalDelete] = useState({
    show: false,
    value: null,
  });
  const [isModalReject, setIsModalReject] = useState({
    show: false,
    value: null,
  });
  const [isModalExclude, setIsModalExclude] = useState({
    show: false,
    value: null,
  });
  const [passportHistoryModal, setPassportHistoryModal] = useState(null);

  useEffect(async () => {
    await getData();
  }, [year, filterStatus]);

  const getData = async () => {
    try {
      let result = await api.get(
          BaseRequests.getUrlSearch('/factdata/teammembers',{projId,portfId:portfolioId,year,status:filterStatus})
      );
      let index = 1;
      result = result.data;
      setMembers(
        result.map((e) => {
          e.fullName = `${e.lastName} ${e.firstName} ${e.middleName}`;
          e.isYoungString = e.isYoung ? 'Да' : 'Нет';
          e.roleString = roles[e.role];
          e.statusString = status[e.status] || e.status;
          e.employmentDateString = dateRenderer(e.employmentDate);
          e.exclusionDateString = dateRenderer(e.exclusionDate);
          e.inclusionDateString = dateRenderer(e.inclusionDate);
          e.index = index++;
          return e;
        }),
      );
    } catch (error) {
    }
  };

  const handleSend = async (id) => {
    const response = await api.post(`/factdata/teammembers/${id}/send`);
    if (!response.error) {
      const dataCopy = [...members];
      const tm = dataCopy.find((t) => t.id === id);
      tm.status = 'onApprove';
      setMembers((prev) => dataCopy);
    } else toast.error(response?.error?.message || 'Не удалось произвести операцию');
  };

  const handleReject = async (comment) => {
    const response = await api.post(`/factdata/teammembers/${isModalReject.value}/reject`, { comment });
    if (!response.error) {
      const dataCopy = [...members];
      const tm = dataCopy.find((t) => t.id === isModalReject.value);
      tm.status = 'rejected';
      tm.comment = comment;
      setMembers((prev) => dataCopy);
      setIsModalReject({ show: false, value: null });
    } else toast.error(response?.error?.message || 'Не удалось произвести операцию');
  };

  const handleApprove = async (id) => {
    const response = await api.post(`/factdata/teammembers/${id}/approve`);
    if (!response.error) {
      const dataCopy = [...members];
      const tm = dataCopy.find((t) => t.id === id);
      tm.status = 'approved';
      setMembers((prev) => dataCopy);
    } else toast.error(response?.error?.message || 'Не удалось произвести операцию');
  };

  const handleDelete = async () => {
    const result = await api.del(`/factdata/teammembers/${isModalDelete.value}`, {id: isModalDelete.value});
    if (result && !result.error) {
      toast.success('Участник команды успешно удален');
      setMembers((prev) => prev.filter((v) => v.id !== isModalDelete.value));
    }
    setIsModalDelete({ show: false, value: null });
  };

  const handleExclude = async (comment, exclusionDate) => {
    const inc = moment(members.find((e)=>e.id==isModalExclude.value).inclusionDate.split("T")[0],"YYYY-MM-DD")
    const exc=moment(exclusionDate,"YYYY-MM-DD")
    if(exc.isBefore(inc)){
      toast.error("Дата исключения не может быть раньше даты включения");
      return;
    }
    const response = await api.post(`/factdata/teammembers/${isModalExclude.value}/exclude`, {exclusionDate, comment });
    if (!response.error) {
      const dataCopy = [...members];
      const tm = dataCopy.find((t) => t.id === isModalExclude.value);
      tm.status = 'excluded';
      tm.comment = comment;
      setMembers((prev) => dataCopy);
      setIsModalExclude({ show: false, value: null });
    } else toast.error(response?.error?.message || 'Не удалось произвести операцию');
  };

  const actions = {
    edit: (id, projId) => setEditMemberID(id), // history.replace(`/strats/${stratId}/portfolios/${portfolioId}/projs/${projId}/members/${id}`),
    send: async (id) => await handleSend(id),
    approve: async (id) => await handleApprove(id),
    reject: async (id) => setIsModalReject({ show: true, value: id }),
    delete: async (id) => setIsModalDelete({ show: true, value: id }),
    exclude: async (id) => setIsModalExclude({ show: true, value: id }),
  };

  const getCols = () => {
    const firstStickyCols=[
      canEdit && {
            title: 'Действ',
            render: (rowData) => (
                <FactDataActions
                    props={{ ...rowData, entityType: 'teamMember', style: { zIndex:15 } }}
                    actions={actions}
                    userCtx={userCtx}
                    stratId={stratId}
                    portfId={portfolioId}
                    policyId={policyId}
                />
            ),
            width: 80,
          },
          {
            title: 'Статус',
            field: 'status',
            render: ({ status, comment }) => (comment
                ? <TooltippedElement tooltip={comment}><StatusBadge type={'teamMember'} status={status} /></TooltippedElement>
                : <StatusBadge type={'teamMember'} status={status} />),
            width: '170px',
          },
        ]
    const baseCollsFirst = [...firstStickyCols,
      {
        title: "ФИО участника",
        field: "fullName",
        filtering:true,
        width: 200,
        cellStyle: {minWidth: "200px"},
        render: (rowData) => (
            <span onClick={() => setEditMemberID(rowData.id)} style={{cursor: "pointer", color: "#0D6EFD"}}>
                    {rowData.fullName}
                  </span>
        ),
      }]
    const collsFirst = getStickyColumns(baseCollsFirst,0)


    const restCols = [{
      title: <div style={{width: "140px"}}>Роль</div>,
      field: "roleString",
      width: 140,
      lookup: arrayToLookup("roleString", members,),
      filterComponent: FilterMultiSelect
    },
      {
        title: "Должность",
        field: "post",
        width: 180,
        cellStyle: {minWidth: "180px"},
        lookup: arrayToLookup("post", members,),
        filterComponent: FilterMultiSelect
      },
      {
        title: "Вид трудоустройства",
        field: "employmentType",
        width: 140,
        cellStyle: {minWidth: "140px"},
        lookup: arrayToLookup("employmentType", members,),
        filterComponent: FilterMultiSelect
      },
      {
        title: "Доля занимаемой ставки",
        field: "rate",
        width: 150,
        cellStyle: {minWidth: "150px"},
      },
      {
        title: "% участия в проекте",
        field: "share",
        cellStyle: {minWidth: "140px"},
        width: '140px',
        // filterCellStyle:{maxWidth:'180px'},
        // headerStyle:{width:'180px'},
        render: (rowData) => rowData.share*100
      },
      // {
      //   title: "Дата приема/перевода на научную ставку",
      //   field: "employmentDateString",
      //   cellStyle: {minWidth: "200px"},
      // },
      {
        title: "Подразделение",
        field: "division",
        // width: '220px',
        // headerStyle:{minWidth:'220px'},
        cellStyle: {minWidth: "220px"},
      },
      {
        title: "Дата включения в проект",
        field: "inclusionDateString",
        width: '120px',
        // headerStyle:{minWidth:'120px'},
        cellStyle: {minWidth: "120px"},
      },
      {
        title: "Дата исключения из проекта",
        field: "exclusionDateString",
        width: '120px',
        // headerStyle:{minWidth:'120px'},
        cellStyle: {minWidth: "120px"},
      },
      {
        title: "Сотрудник до 39 лет",
        field: "isYoungString",
        width: '100px',
        // headerStyle:{minWidth:'150px'},
        cellStyle: {minWidth: "150px"},
        lookup: arrayToLookup("isYoungString", members),
        filterComponent: FilterMultiSelect
      },
    ]
    return [...collsFirst,...restCols]
  }

  if (error) {
    return (
      <div style={{ color: 'red', background: 'white' }}>
        Ошибка:
        {error.message}
      </div>
    );
  } if (!isLoaded) {
    return (
        <section className="page projects-page">
          <div>Загрузка...</div>
        </section>
    );
  }


  return (
    <div className="tab-subproject-register" style={{ color: 'initial' }}>
      <div style={styledTable}>
        <MaterialTable
          components={{
            Container: (props) => (
                <div className="special-filter-without-max" {...props} />
            ),
            Body: (props) => (
                <>
                  <MTableBody {...props}/>
                  <div id="portal-root"></div>
                </>
            ),
            Header: (props) => (<MTableHeader {...props} tableHeadStyle={styledHeaderSticky} />),
          }}
          title=""
          options={modifyDefaultOptions({
            pageSize: 15,
            pageSizeOptions: [15, 30, 50],
            headerStyle: {
              fontSize: 12,
              lineHeight: 1.3,
              padding: '8px 16px',

              zIndex: 0,

            },
            filterCellStyle: {
              padding: '8px 16px',
              position: 'sticky',
              top: 72,
              background: 'white',
            },
            filtering: true,
            sorting: true,
            search: false,
            paging: true,

            maxBodyHeight: 'calc(100vh - 476px)',
          })}
          icons={tableIcons}
          localization={localization}
            columns={objectToCols(getCols())}
                data={members}
            />
          </div>
          {passportHistoryModal && (
              <PassportVersionHistoryModal pass={passportHistoryModal} onClose={() => setPassportHistoryModal(null)}/>
          )}
          <ModalSendForRevision
              show={isModalReject.show}
              onClose={() => setIsModalReject({show: false, value: null})}
              onSubmit={(comment) => handleReject(comment)}
              headerText="Не согласовать"
              label="Комментарий"
          />
          {isModalExclude.show&&<ModalSendForRevisionWithDate
              show={isModalExclude.show}
              onClose={() => setIsModalExclude({show: false, value: null})}
              onSubmit={(comment, date) => handleExclude(comment, date)}
              headerText="Исключение участника"
              label="Комментарий"
              labelDate="Дата исключения"
          />}
          <ConfirmModal
              show={isModalDelete.show}
              onClose={() => setIsModalDelete({show: false, value: null})}
              onConfirm={() => handleDelete()}
              headerText="Удаление участника команды"
              message="Участник команды будет удален, данное действие нельзя отменить. Удалить участника команды?"
          />
        </div>
    );
  }


const styledTable = {
  maxWidth: '100%',
};
